export default __webpack_public_path__ + "static/media/B_Baleia.fa422e2f.mp3";